module.exports = __webpack_public_path__ + "images/audio01.png?5d04e7d2a250e564430486f01a49feec";


//////////////////
// WEBPACK FOOTER
// ./static/images/audio01.png
// module id = 178
// module chunks = 0